import axios from "axios";

/**
    * @function getClassDetailService 
    * @param (classSlug, id)
    * @description This function is used to get class details
*/
export const getClassDetailService = async (classSlug, id) => {
    try {
        const result = await axios.get(`user/class-detail/${classSlug}/${id}`);
        return result;
    } catch (error) {
        return error;
    }
};